import { Pagination } from '@mantine/core';
import { IconChevronLeft, IconChevronRight } from 'ui-icons';

import classes from './Pagination.module.css';

const PaginationDefaults = Pagination.extend({
  defaultProps: {
    previousIcon: (props) => <IconChevronLeft {...props} />,
    nextIcon: (props) => <IconChevronRight {...props} />,
  },
  classNames: {
    root: classes.root,
    control: classes.control,
    dots: classes.dots,
  },
});

export { Pagination, PaginationDefaults };
